function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomKitchenFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7l-3-2.25V2H6v2.75L3 7v3h16V7zM5 8l3-2.25V4h6v1.75L17 8H5zm21 12h-4v-2h4v2zm3-6V9.75c0-.29-.08-.69-.34-1.05-.3-.41-.79-.7-1.41-.7h-1.5c-.28 0-.69.08-1.05.34-.41.3-.7.79-.7 1.41v.75h2V10h1v4h-4v-1h-2v1h-6v-1h-2v1H9v-1H7v1H2v16h28V14h-1zM18 28H4v-8h5v2h4v-2h5v8zm0-10H4v-2h14v2zm10 10h-8V16h8v12z",
    fill: props.color
  }));
}

export default SvgIconRoomKitchenFilled;